import { render, staticRenderFns } from "./stitched_nets_stock.vue?vue&type=template&id=8a0c01d0&scoped=true"
import script from "./stitched_nets_stock.vue?vue&type=script&lang=js"
export * from "./stitched_nets_stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0c01d0",
  null
  
)

export default component.exports